import { SIGNAL_TYPE_DEFINITIONS } from '@parcel/types';
import type { EntityFilterSchema, FilterEnumValue } from '../types.js';

export const SIGNAL_TYPE_FILTER_OPTIONS: readonly FilterEnumValue[] = SIGNAL_TYPE_DEFINITIONS.map(
  ({ value, label, description }) => ({ value, label, description }),
);

export const SIGNAL_STATUS_OPTIONS: readonly FilterEnumValue[] = [
  { value: 'new', label: 'New', description: 'Not yet worked by the team' },
  { value: 'done', label: 'Done', description: 'Marked done and out of the queue' },
];

export const SIGNAL_PRIORITY_OPTIONS: readonly FilterEnumValue[] = [
  { value: 'high', label: 'High', description: 'High-priority subscribed signal types' },
  { value: 'medium', label: 'Medium', description: 'Medium-priority subscribed signal types' },
  { value: 'low', label: 'Low', description: 'Low-priority subscribed signal types' },
];

export const signalFilters: EntityFilterSchema = {
  entity: 'signal',
  fields: [
    {
      type: 'text',
      key: 'q',
      label: 'Search',
      description: 'Free-text search over project names, addresses, sources, and filing IDs.',
    },
    {
      type: 'enum',
      key: 'status',
      label: 'Status',
      description: 'Triage status of the signal in Notifications.',
      multi: true,
      values: SIGNAL_STATUS_OPTIONS,
    },
    {
      type: 'enum',
      key: 'signal_type',
      label: 'Signal type',
      description: 'Filter by one or more signal types.',
      multi: true,
      values: SIGNAL_TYPE_FILTER_OPTIONS,
    },
    {
      type: 'enum',
      key: 'priority',
      label: 'Priority',
      description: 'Workspace subscription priority of the signal type.',
      multi: true,
      values: SIGNAL_PRIORITY_OPTIONS,
    },
    {
      type: 'dynamic-enum',
      key: 'city',
      label: 'City',
      description: 'Filter by the city of the signal’s project.',
      multi: true,
      valueSource: 'derived-rows',
    },
  ],
};
